<template>
    <with-dimensions
        v-slot="{
            width
        }"
    >
        <table-ish>
            <slot
                name="header"
                :width="width"
            />

            <table-ish-row-router-link
                v-for="rent in rents"
                :key="rent.uuid"
                :to="{
                    name: $router.fix('dashboard.*.rents.show'),
                    params: {
                        rent: rent.uuid
                    }
                }"
            >
                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    class="text-right"
                >
                    <span class="px-3 py-1 text-sm font-semibold rounded-full bg-grey-lighter text-grey-darker">
                        Rent
                    </span>
                </table-ish-cell>

                <table-ish-cell>
                    <truncate-hack>
                        {{ rent.due_at_original | moment('D MMM YYYY') }}
                    </truncate-hack>

                    <truncate-hack slot="secondary">
                        <span
                            v-if="width <= 500"
                            class="px-2 mr-1 leading-none rounded-full bg-grey-lighter text-grey-darker"
                        >
                            Rent
                        </span>

                        {{ $gate.role('landlord') ? rent.property.name : rent.property.address.name }}
                    </truncate-hack>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    {{ rent.charged | money }}
                </table-ish-cell>
            </table-ish-row-router-link>

            <table-ish-row
                v-for="fee in fees"
                :key="fee.uuid"
            >
                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    class="text-right"
                >
                    <span class="px-3 py-1 text-sm font-semibold rounded-full bg-grey-lighter text-grey-darker">
                        Fee
                    </span>
                </table-ish-cell>

                <table-ish-cell>
                    <truncate-hack>
                        {{ fee.title }}
                    </truncate-hack>

                    <truncate-hack slot="secondary">
                        <span
                            v-if="width <= 500"
                            class="px-2 mr-1 leading-none rounded-full bg-grey-lighter text-grey-darker"
                        >
                            Fee
                        </span>

                        {{ $gate.role('landlord') ? fee.property.name : fee.property.address.name }}
                    </truncate-hack>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    {{ fee.charged | money }}
                </table-ish-cell>
            </table-ish-row>

            <slot
                name="footer"
                :width="width"
            />
        </table-ish>
    </with-dimensions>
</template>

<script>
    export default {
        props: {
            rents: {
                type: Array,
                default: () => []
            },
            fees: {
                type: Array,
                default: () => []
            }
        }
    }
</script>
